import { ContentDomReadyTracker, LastVisitTracker, SessionTracking } from '@core/analytics'
import { useCurrentUser } from '@features/session'

import { DeviceFingerprintContainer } from './DeviceFingerprintContainer'
import { SessionContextTracker } from './SessionContextTracker'

export const AppAnalyticsContainer = () => {
    const { id: userId } = useCurrentUser()

    return (
        <>
            <SessionTracking />
            <LastVisitTracker />
            <ContentDomReadyTracker />
            <SessionContextTracker userId={userId} />
            <DeviceFingerprintContainer userId={userId} />
        </>
    )
}
